import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { TableHead, Typography } from "@mui/material";
import { resetCode } from "../../services/promocode.service";

import moment from "moment";
import "moment-timezone";
import { UseCountdown } from "../useCountdown";
import Swal from "sweetalert2";
import { FormattedMessage, useIntl } from "react-intl";

const TableCodes = ({ rows }) => {
  const intl = useIntl();
  const timestamp_now = new Date().getTime();
  const showMore = async (row, index) => {
    let startStr =
      `<table class="table-used-code" style="border-collapse: collapse"><thead><tr>` +
      `<th>${intl.formatMessage({ id: 'username', defaultMessage: 'Username' })}</th>` +
      `<th>${intl.formatMessage({ id: 'name', defaultMessage: 'Name' })}</th>` +
      `<th>Ip</th>` +
      `<th>Fp</th>` +
      `<th>${intl.formatMessage({ id: 'timeGmt7', defaultMessage: 'Time (GMT+7)' })}</th>` +
      `</tr></thead><tbody>`;
    const endStr = "</tbody></table>"; //
    let bodyStr = "";
    row?.receiveUsers.forEach((el) => {
      bodyStr += `<tr><td>${el.user_used}</td> <td>${el.name}</td> <td>${el.ip}</td> <td>${el.fp}</td> <td>${moment(el.used_time)
        .tz("Asia/Ho_Chi_Minh")
        .format("DD/MM/YYYY H:mm:ss")}</td></tr>`;
    });
    return Swal.fire({
      title: intl.formatMessage({ id: 'userCodeInfo', defaultMessage: 'User Code Information' }),
      html: startStr + bodyStr + endStr,
      showConfirmButton: false,
      showCloseButton: true,
      width: 800,
    });
  };

  const handleReset = async (row) => {
    const confirm = await Swal.fire({
      title: intl.formatMessage({ id: "confirmReset", defaultMessage: "Confirm reset?" }),
      text: `${intl.formatMessage({ id: "promoCode", defaultMessage: "Promo Code" })}: ${row.promo_code}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({ id: "reset", defaultMessage: "Reset" }),
      cancelButtonText: intl.formatMessage({ id: "cancel", defaultMessage: "Cancel" }),
    });

    if (!confirm.isConfirmed) return;

    const res = await resetCode(row.promo_code);

    if (res?.code === 200) {
      Swal.fire(
        intl.formatMessage({ id: "success", defaultMessage: "Success" }),
        intl.formatMessage({ id: "resetSuccess", defaultMessage: "Reset completed" }),
        "success"
      );
      window.location.reload();
    }
  };

  return (
    <>
      {rows && (
        <Box>
          <TableContainer sx={{ maxHeight: 800 }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 500 }}>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="no" defaultMessage="No." />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="category" defaultMessage="Category" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="releaseCode" defaultMessage="Release Code" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="promoCode" defaultMessage="Promo Code" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="codeType" defaultMessage="Code Type" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="code" defaultMessage="Code" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="additionalActions" defaultMessage="Additional Actions" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="usage" defaultMessage="Usage" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="user" defaultMessage="User" />
                  </TableCell>
                  <TableCell align="left" sx={{ padding: 1, fontWeight: 700 }}>
                    <FormattedMessage id="expiration" defaultMessage="Expiration" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((row, index) => (
                  <TableRow
                    key={row._id}
                    hover
                    className={
                      row.endOf_time > timestamp_now && row.user_used === "" && row.used_time === 0
                        ? "table-row-data row-unused"
                        : row.user_used === "" && row.used_time === 0
                          ? "table-row-data row-exp"
                          : "table-row-data row-used"
                    }
                  >
                    <TableCell sx={{ padding: "0 8px" }} component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ padding: "0 8px" }} component="th" scope="row">
                      {row?.code_send?.toUpperCase()}
                    </TableCell>
                    <TableCell sx={{ padding: "0 8px" }} component="th" scope="row">
                      {row.releaseCode}
                    </TableCell>
                    <TableCell sx={{ padding: "0 8px" }} component="th" scope="row">
                      {row.promo_id}
                    </TableCell>
                    <TableCell sx={{ padding: "0 8px" }} component="th" scope="row">
                      <>
                        <p className="row unused" title="">
                          {row?.type_code === "one_only"
                            ? intl.formatMessage({ id: 'receiveOneCode', defaultMessage: 'Receive 1 code' })
                            : row?.type_code === "one_per_day"
                              ? intl.formatMessage({ id: 'receiveOneCodePerDay', defaultMessage: 'Receive 1 code/day' })
                              : row?.type_code === "one_per_3day"
                                ? intl.formatMessage({ id: 'receiveOneCodePer3Days', defaultMessage: 'Receive 1 code/3 days' })
                                : row?.type_code === "one_per_week"
                                  ? intl.formatMessage({ id: 'receiveOneCodePerWeek', defaultMessage: 'Receive 1 code/week' })
                                  : row?.type_code === "one_per_month"
                                    ? intl.formatMessage({ id: 'receiveOneCodePerMonth', defaultMessage: 'Receive 1 code/month' })
                                    : row?.type_code === "no_limit"
                                      ? intl.formatMessage({ id: 'unlimited', defaultMessage: 'Unlimited' })
                                      : intl.formatMessage({ id: 'undefined', defaultMessage: 'Undefined' })}
                        </p>
                        <p className="cell typeDeposite" title="">
                          <FormattedMessage id="deposit" defaultMessage="Deposit:" />
                          {row?.deposite === "all"
                            ? intl.formatMessage({ id: 'all', defaultMessage: 'All' })
                            : row?.deposite === "more_then"
                              ? ` >= ${row?.depositeCount} (${intl.formatMessage({ id: 'times', defaultMessage: 'times' })}), >= ${row?.depositeTotal} (K)`
                              : row?.deposite === "less_then"
                                ? ` < ${row?.depositeCount} (${intl.formatMessage({ id: 'times', defaultMessage: 'times' })}), < ${row?.depositeTotal} (K)`
                                : ""}
                        </p>
                        <p className="cell typeWithdraw" title="">
                          <FormattedMessage id="withdraw" defaultMessage="Withdraw:" />
                          {row?.withdraw === "all"
                            ? intl.formatMessage({ id: 'all', defaultMessage: 'All' })
                            : row?.withdraw === "more_then"
                              ? ` >= ${row?.withdrawCount} (${intl.formatMessage({ id: 'times', defaultMessage: 'times' })}), >= ${row?.withdrawTotal} (K)`
                              : row?.withdraw === "less_then"
                                ? ` < ${row?.withdrawCount} (${intl.formatMessage({ id: 'times', defaultMessage: 'times' })}), < ${row?.withdrawTotal} (K)`
                                : ""}
                        </p>
                      </>
                    </TableCell>
                    <TableCell sx={{ padding: "0 8px" }} component="th" scope="row">
                      <p>{row.promo_code}</p>
                      <p className="row_user_used">
                        {row.point} <span>(points)</span>
                      </p>
                      <p className="row_fp">
                        {row.round} <span>(betting rounds)</span>
                      </p>
                    </TableCell>
                    <TableCell>
                      <p>{row.checkIPFP === "check" ? intl.formatMessage({ id: 'blockDuplicateIPFP', defaultMessage: 'Block duplicate IP-FP' }) : ""}</p>
                      <p>{row.internalMess === "send" ? intl.formatMessage({ id: 'sendWithMail', defaultMessage: 'Send with mail' }) : ""}</p>
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          background: "#f1f1f1",
                          borderRadius: 2,
                          textAlign: "center",
                          fontSize: "15px",
                          color: `${row?.receiveTotal > row?.receiveCount ? "#0057ff" : "#f00"}`,
                          cursor: "pointer",
                        }}
                        onClick={(e) => showMore(row, index)}
                      >
                        <Typography sx={{ p: 0.5 }} variant="span">
                          {row?.receiveCount}
                        </Typography>
                        |
                        <Typography sx={{ p: 0.5 }} variant="span">
                          {row?.receiveTotal}
                        </Typography>
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ padding: "0 8px" }} align="left">
                      {row?.user_used && (
                        <>
                          <p className="row_ip">{row.ip}</p>
                          <p className="row_user_used">({row.user_used})</p>
                          <p className="row_fp">{row.fp}</p>
                        </>
                      )}
                      {row?.used_time === 0 && row?.user_used === "" && (
                        <p className="row unused" title="">
                          {row?.endOf_time < timestamp_now && intl.formatMessage({ id: 'expired', defaultMessage: 'Expired' })}
                        </p>
                      )}
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }} align="left">
                      <p className="color-green" title={intl.formatMessage({ id: 'startTime', defaultMessage: 'Start Time' })}>
                        {moment(row.startOf_time).tz("Asia/Ho_Chi_Minh").format("DD/MM/Y H:mm")}
                      </p>
                      <p className="color-yellow" title={intl.formatMessage({ id: 'endTime', defaultMessage: 'End Time' })}>
                        {moment(row.endOf_time).tz("Asia/Ho_Chi_Minh").format("DD/MM/Y H:mm")}
                      </p>
                      <p>
                        {row?.endOf_time < timestamp_now && intl.formatMessage({ id: 'expired', defaultMessage: 'Expired' })}
                        {row?.endOf_time > timestamp_now && row?.used_time === 0 && row?.user_used === "" && <UseCountdown targetDate={row?.endOf_time} />}
                        {row?.used_time !== 0 && row?.user_used !== "" && (
                          <p>
                            {moment(row.used_time).tz("Asia/Ho_Chi_Minh").format("DD/MM/Y H:mm")} <i className="fa-solid fa-check-double"></i>
                          </p>
                        )}
                      </p>
                    </TableCell>
                    {/* <TableCell>
                      {row?.user_used && row?.used_time !== 0 && (
                        <Typography
                          sx={{
                            color: "#f44336",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: "14px",
                          }}
                          onClick={() => handleReset(row)}
                        >
                          <FormattedMessage id="reset" defaultMessage="Reset" />
                        </Typography>
                      )}
                    </TableCell>*/}
                  </TableRow>
                ))}
                {rows.length === 0 && (
                  <TableRow style={{ height: 53 }}>
                    <TableCell colSpan={10} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};

export default TableCodes;
